/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get("recently-viewed-products")) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url =
        theme.routes.search_url + "?view=recently-viewed&type=product&q=";
      this.container = this.querySelector(".products");
      this.currentId = this.dataset.productHandle;
      this.max = 4;
      this.recentIds = [];
      try {
        const recentIds = JSON.parse(window.localStorage.getItem("recently-viewed") || "[]");
        if (Array.isArray(recentIds)) {
          this.recentIds = recentIds.filter((id) => typeof id === "string");
        }
      } catch (_) {
        // Storage can be unavailable or contain an outdated value.
      }
    }
    connectedCallback() {
      this.buildUrl();
    }
    buildUrl() {
      this.container = this.querySelector(".products");
      this.currentId = this.dataset.productHandle || this.currentId;
      if (!this.container || this.loading || this.classList.contains("product-recommendations--loaded")) return;
      const handles = [...new Set(this.recentIds)].filter((id) => id !== this.currentId && /^[a-z0-9-]+$/i.test(id)).slice(0, this.max);
      if (!handles.length) return;
      const query = handles.map((id) => "handle:" + id).join(" OR ");
      this.fetchProducts(this.url + encodeURIComponent(query));
    }
    fetchProducts(url) {
      this.loading = true;
      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error("Recently viewed request failed: " + response.status);
          return response.text();
        })
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector(".products");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => { this.loading = false; });
    }
  }

  customElements.define("recently-viewed-products", RecentlyViewedProducts);
}
